import { Link } from 'react-router-dom';
import { logo } from '../assets';
import { NavStyles } from '../styles/styles';

const Nav = () => {
  return (
    <NavStyles>
      <Link className="logo nav-button tap-highlight-transparent" to="/">
        <img
          className="sm:opacity-[0.8] opacity-[0.6] tap-highlight-transparent"
          src={logo}
          alt="logo"
        />
      </Link>

      <div className="flex items-center justify-center">
        <Link
          className="projects nav-button tap-highlight-transparent"
          to="/projects">
          Projects
        </Link>
        <Link
          className="about nav-button tap-highlight-transparent"
          to="/about">
          About
        </Link>
      </div>
    </NavStyles>
  );
};

export default Nav;
